// Updated only from the authenticated WhoAmI response, never from URL parameters.
let identified=false,key="";
export const setProductUsageIdentified=(value:boolean,identityKey="")=>{const changed=identified!==value||key!==identityKey;identified=value;key=identityKey;if(changed)window.dispatchEvent(new Event("wt:usage-identity"));};
export const isProductUsageIdentified=()=>identified;
